import { render, staticRenderFns } from "./DataSheets.vue?vue&type=template&id=1223e45e&scoped=true"
import script from "./DataSheets.vue?vue&type=script&lang=ts"
export * from "./DataSheets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223e45e",
  null
  
)

export default component.exports